import React from 'react';

export default ({ className, ...other }) => (
  <svg
    className="icon w16"
    viewBox="0 0 16.609 16.609"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <g id="Group_457" data-name="Group 457" transform="translate(0)">
      <g id="flaticon1567704307-svg" transform="translate(0)">
        <path id="Path_1129" data-name="Path 1129" d="M8.3,0a8.3,8.3,0,1,0,8.3,8.3A8.314,8.314,0,0,0,8.3,0Zm0,16.055A7.751,7.751,0,1,1,16.055,8.3,7.76,7.76,0,0,1,8.3,16.055Z" fill="#54c6e0" />
      </g>
      <g id="flaticon1567706235-svg" transform="translate(4.854 3.033)">
        <path id="Path_1133" data-name="Path 1133" d="M21.238,3.369a3.369,3.369,0,1,0-3.594,3.357v4.481a.225.225,0,0,0,.449,0V6.726A3.37,3.37,0,0,0,21.238,3.369Zm-3.369,2.92a2.92,2.92,0,1,1,2.92-2.92A2.923,2.923,0,0,1,17.869,6.289Z" transform="translate(-14.5)" fill="#54c6e0" />
        <path id="Path_1134" data-name="Path 1134" d="M21.4,7a.9.9,0,1,0,.9.9A.9.9,0,0,0,21.4,7Zm0,1.348a.449.449,0,1,1,.449-.449A.45.45,0,0,1,21.4,8.348Z" transform="translate(-19.152 -5.428)" fill="#54c6e0" />
      </g>
    </g>
  </svg>
);
